import { Box, Table, Text } from '@factorialco/deprecated-design-system'
import {
  ShiftManagementShiftConfigurationFragment,
  ShiftManagementTemplateWeekFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { shiftDaysSortedByStartingWeekday } from 'modules/shift_management/store/api/models/ShiftConfiguration'

import TableCell from '../Cell'

interface Props {
  templateWeek: ShiftManagementTemplateWeekFragment
  shiftConfigs: ShiftManagementShiftConfigurationFragment[]
}

const TableRow = ({ templateWeek, shiftConfigs }: Props) => {
  const {
    access: { firstDayOfWeek },
  } = useCurrentSession()

  // eg: If user chooses to start the week on Wed, then it returns [2, 3, 4, 5, 6, 0, 1]
  const weekdaysStartingByUserFirstDayOfWeek = shiftDaysSortedByStartingWeekday(firstDayOfWeek)

  return (
    <Table.Row>
      <Table.Cell verticalAlign="top">
        <Box width="s140">
          <Text.Normal color="grey1000" ellipsis>
            {templateWeek.name}
          </Text.Normal>
        </Box>
      </Table.Cell>
      {weekdaysStartingByUserFirstDayOfWeek.map((day, index) => (
        <Table.Cell key={index} verticalAlign="top">
          <Box gap="s8">
            <TableCell day={day} templateWeek={templateWeek} shiftConfigs={shiftConfigs} />
          </Box>
        </Table.Cell>
      ))}
    </Table.Row>
  )
}

export default observer(TableRow)
